// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TableOutlinedSvg from "@fishx/icons-svg/es/asn/TableOutlined";
import FishxIcon from '../components/FishxIcon';

var TableOutlined = function TableOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TableOutlinedSvg
  }));
};

TableOutlined.displayName = 'TableOutlined';
export default React.forwardRef(TableOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TableOutlined.js
// module id = 4221
// module chunks = 0